import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../common/DataTable';
import DateTimeDisplay from '../common/DateTimeDisplay';

export default function FormDefinitionsTable({ items, onOpenForm, filterExtras = null }) {
  const columns = [
    {
      key: 'slug',
      label: 'Slug',
      sortable: true,
      icon: 'bi-hash',
      render: (row) => (
        <button
          type="button"
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => onOpenForm?.(row)}
        >
          <code className="small">{row.slug}</code>
        </button>
      ),
      filterValue: (row) => row.slug || '',
    },
    {
      key: 'title',
      label: 'Title',
      sortable: true,
      icon: 'bi-card-heading',
      render: (row) => (
        <button
          type="button"
          className="btn btn-link p-0 text-decoration-none fw-semibold"
          onClick={() => onOpenForm?.(row)}
        >
          {row.title}
        </button>
      ),
      filterValue: (row) => row.title || '',
    },
    {
      key: 'scope',
      label: 'Scope',
      sortable: true,
      icon: 'bi-globe2',
      render: (row) =>
        row.organization_id == null ? (
          <span className="text-muted small">Global (read-only)</span>
        ) : (
          <span className="small">Organization</span>
        ),
      filterValue: (row) => (row.organization_id == null ? 'Global' : 'Organization'),
    },
    {
      key: 'in_use',
      label: 'In use',
      sortable: true,
      icon: 'bi-diagram-3',
      // No pill here on purpose: a column of alternating green and grey lozenges reads as a
      // column of states that need attention, when the fact is a yes or a no.
      render: (row) =>
        row.in_use ? (
          <i className="bi bi-check-lg text-success-emphasis" role="img" aria-label="In use" />
        ) : (
          <span className="text-muted" aria-label="Not in use">—</span>
        ),
      filterValue: (row) => (row.in_use ? 'in use yes' : 'not in use no'),
    },
    {
      key: 'updated_at',
      label: 'Updated',
      sortable: true,
      icon: 'bi-clock-history',
      render: (row) => <DateTimeDisplay isoString={row.updated_at} />,
      filterValue: (row) => row.updated_at || '',
    },
  ];

  return (
    <DataTable
      items={items}
      columns={columns}
      actions={[]}
      filterExtras={filterExtras}
      filterPlaceholder="Search forms…"
      emptyMessage="No forms found."
    />
  );
}

FormDefinitionsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onOpenForm: PropTypes.func,
  filterExtras: PropTypes.node,
};
